import i18next from "i18next"
import googlePlayBadgeCs from "../assets/google_play_badges/google_play_badge_cs.webp"
import googlePlayBadgeDa from "../assets/google_play_badges/google_play_badge_da.webp"
import googlePlayBadgeDe from "../assets/google_play_badges/google_play_badge_de.webp"
import googlePlayBadgeEl from "../assets/google_play_badges/google_play_badge_el.webp"
import googlePlayBadgeEn from "../assets/google_play_badges/google_play_badge_en.webp"
import googlePlayBadgeEs from "../assets/google_play_badges/google_play_badge_es.webp"
import googlePlayBadgeFi from "../assets/google_play_badges/google_play_badge_fi.webp"
import googlePlayBadgeFr from "../assets/google_play_badges/google_play_badge_fr.webp"
import googlePlayBadgeHi from "../assets/google_play_badges/google_play_badge_hi.webp"
import googlePlayBadgeHr from "../assets/google_play_badges/google_play_badge_hr.webp"
import googlePlayBadgeHu from "../assets/google_play_badges/google_play_badge_hu.webp"
import googlePlayBadgeIt from "../assets/google_play_badges/google_play_badge_it.webp"
import googlePlayBadgeNl from "../assets/google_play_badges/google_play_badge_nl.webp"
import googlePlayBadgeNo from "../assets/google_play_badges/google_play_badge_no.webp"
import googlePlayBadgePl from "../assets/google_play_badges/google_play_badge_pl.webp"
import googlePlayBadgePt from "../assets/google_play_badges/google_play_badge_pt.webp"
import googlePlayBadgeRo from "../assets/google_play_badges/google_play_badge_ro.webp"
import googlePlayBadgeRu from "../assets/google_play_badges/google_play_badge_ru.webp"
import googlePlayBadgeSv from "../assets/google_play_badges/google_play_badge_sv.webp"
import googlePlayBadgeZh from "../assets/google_play_badges/google_play_badge_zh.webp"

// NOTE: Download the official badges here: https://partnermarketinghub.withgoogle.com/brands/google-play/visual-identity/badge-guidelines/?folder=65627

const googlePlayBadges: Record<string, string> = {
  cs: googlePlayBadgeCs,
  da: googlePlayBadgeDa,
  de: googlePlayBadgeDe,
  el: googlePlayBadgeEl,
  en: googlePlayBadgeEn,
  es: googlePlayBadgeEs,
  fi: googlePlayBadgeFi,
  fr: googlePlayBadgeFr,
  hi: googlePlayBadgeHi,
  hr: googlePlayBadgeHr,
  hu: googlePlayBadgeHu,
  it: googlePlayBadgeIt,
  nl: googlePlayBadgeNl,
  no: googlePlayBadgeNo,
  pl: googlePlayBadgePl,
  pt: googlePlayBadgePt,
  ro: googlePlayBadgeRo,
  ru: googlePlayBadgeRu,
  sv: googlePlayBadgeSv,
  zh: googlePlayBadgeZh,
}

export default function getGooglePlayBadge(): string {
  const language = i18next.language.split("-")[0]

  return googlePlayBadges[language] || googlePlayBadgeEn
}
